import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f979b020"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageOutlined = _resolveComponent("MessageOutlined")!
  const _component_a_list_item_meta = _resolveComponent("a-list-item-meta")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    title: "Notifications",
    onDownload: _cache[2] || (_cache[2] = ($event: any) => (_ctx.visible = true))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_list, {
          "item-layout": "horizontal",
          "data-source": _ctx.items.data
        }, {
          renderItem: _withCtx(({ item }) => [
            _createVNode(_component_a_list_item, {
              class: "notif",
              style: _normalizeStyle([{"padding":"10px","cursor":"pointer"}, item.is_read ? '' : 'background: #bbe6ff']),
              onClick: ($event: any) => (_ctx.goToNotif(item))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_list_item_meta, {
                  description: item.date
                }, {
                  title: _withCtx(() => [
                    _createElementVNode("a", null, [
                      _createElementVNode("b", null, _toDisplayString(item.description), 1)
                    ])
                  ]),
                  avatar: _withCtx(() => [
                    _createVNode(_component_MessageOutlined, { style: {fontSize: '16px', color: '#08c'} })
                  ]),
                  _: 2
                }, 1032, ["description"])
              ]),
              _: 2
            }, 1032, ["style", "onClick"])
          ]),
          _: 1
        }, 8, ["data-source"]),
        _hoisted_2,
        _createVNode(_component_a_pagination, {
          current: _ctx.current,
          "onUpdate:current": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.current) = $event)),
          total: _ctx.items.total,
          "page-size": 15,
          "show-less-items": "",
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeNotifPage(_ctx.current)))
        }, null, 8, ["current", "total"])
      ])
    ]),
    _: 1
  }))
}